export const resizeImageUrl = (imageUrl: string, width: number, height: number) => {
  const encodedUrl = encodeURIComponent(imageUrl);
  return `https://imgproxy.c-group.online/plain/rs:fill:${width}:${height}/plain/${encodedUrl}`;
};
